import customer from "@/http/requests/customer"

export default {
  fetch({ commit }, searchParams = {}) {
    return new Promise((resolve, reject) => {
      let concatResults = false

      if (searchParams.concatResults) {
        concatResults = searchParams.concatResults
        delete searchParams.concatResults
      }
      if (searchParams.instance_ids !== undefined && searchParams.instance_ids.length === 0) {
        delete searchParams.instance_ids
      }

      customer.fetch(searchParams).then(response => {
        commit('SET_CUSTOMERS', {
          concatResults,
          customers: response.data.data.customers
        })
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  fetchByCustomerGroup({ commit }, searchParams = {}) {
    return new Promise((resolve, reject) => {
      let concatResults = false
      if (searchParams.concatResults) {
        concatResults = searchParams.concatResults
        delete searchParams.concatResults
      }
      customer.fetchByCustomerGroup(searchParams).then(response => {
        commit('SET_CUSTOMERS', {
          concatResults,
          customers: response.data.data.customers
        })
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  infos({ commit }, customerId) {
    return new Promise((resolve, reject) => {
      customer.infos(customerId).then(response => {
        commit('SET_CUSTOMER_INFOS', response.data.data.customerInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  add(_, data) {
    return new Promise((resolve, reject) => {
      customer.add(data).then(response => {
        // commit('ADD_CUSTOMER', response.data.data.createCustomer)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      customer.update(data).then(response => {
        commit('UPDATE_CUSTOMER', response.data.data.updateCustomer)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, customerId) {
    return new Promise((resolve, reject) => {
      customer.delete(customerId).then(response => {
        commit('DELETE_CUSTOMER', customerId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  softDelete({ commit }, customerId) {
    return new Promise((resolve, reject) => {
      customer.softDelete(customerId).then(response => {
        commit('SOFT_DELETE_CUSTOMER', customerId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  fetchUnchosen({ commit }, {searchParams, chosenCustomersIds}) {

    return new Promise((resolve, reject) => {
      customer.fetchUnchosen(searchParams, chosenCustomersIds).then(response => {
        commit('SET_CUSTOMERS', response.data.data.customers.items)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
}
